import { render, staticRenderFns } from "./plagiarism_detected.vue?vue&type=template&id=271b7158&scoped=true&"
import script from "./plagiarism_detected.vue?vue&type=script&lang=js&"
export * from "./plagiarism_detected.vue?vue&type=script&lang=js&"
import style0 from "./plagiarism_detected.vue?vue&type=style&index=0&id=271b7158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b7158",
  null
  
)

export default component.exports